import { AxiosRequestConfig } from "axios";
import api from "../api-instance";
import {
  Usina,
  PostUsina,
  PatchUsina,
  Indicators,
  Location,
  Support,
  UsinaByClient,
  RelatorioDiarioData,
  RelatorioMensalData,
  RelatorioContent,
  RelatorioPersonalizadoData,
  RelatorioParcialData,
} from "../../../modules/usinas/types";

const ROUTE = "/Usina";
//TODO: Aplicar parâmetros quando a paginação e ordenação do Back End estiver finalizada
export async function getUsinas(
  showDeleted?: boolean,
  onlyWithIndicators?: boolean,
): Promise<{ data: Usina[]; total: number }> {
  // page: number = 1,
  // search: string = "",
  // params?: Partial<Usina>,
  // limit: number = 1000
  const config: AxiosRequestConfig = {
    params: {
      showDeleted: showDeleted,
      onlyWithIndicators: onlyWithIndicators,
      //   _page: page,
      //   _limit: limit,
      //   q: search,
      //   ...params,
    },
  };
  const result = await api.get<Usina[]>(ROUTE, config);
  return {
    data: result.data,
    total: parseInt(result.headers["x-total-count"]),
  };
}
export async function getUsina(id: string) {
  const result = await api.get<Usina>(`${ROUTE}/${id}`);

  return result.data;
}

export async function postUsina(usina: PostUsina): Promise<{ id: string }> {
  const result = await api.post(ROUTE, usina);
  return result.data;
}
export async function patchUsina(
  usinaId: string,
  usina: PatchUsina,
): Promise<{ id: string }> {
  const result = await api.patch(`${ROUTE}/${usinaId}/detalhes`, usina);
  return result.data;
}

export async function deleteUsina(id: string): Promise<{ id: string }> {
  const result = await api.delete(`${ROUTE}/${id}`);
  return result.data;
}

export async function patchIndicators(
  usinaId: string,
  indicators: Indicators,
): Promise<Indicators> {
  const result = await api.patch(`${ROUTE}/${usinaId}/indicadores`, indicators);
  return result.data;
}
export async function patchUsinaName(
  usinaId: string,
  name: string,
): Promise<{ id: string }> {
  const result = await api.patch(`${ROUTE}/${usinaId}/nome`, { name });
  return result.data;
}

export async function patchUsinaIsRemoved(
  usinaId: string,
): Promise<{ isRemoved: boolean }> {
  const result = await api.patch(`${ROUTE}/${usinaId}/isRemovedToFalse`);
  return result.data;
}

export async function patchUsinaLocation(
  usinaId: string,
  location: Location,
): Promise<{ id: string }> {
  const result = await api.patch(`${ROUTE}/${usinaId}/localizacao`, location);
  return result.data;
}
export async function patchUsinaSupport(
  usinaId: string,
  support: Support,
): Promise<{ id: string }> {
  const result = await api.patch(`${ROUTE}/${usinaId}/suporte`, support);
  return result.data;
}
export async function getUsinasByClientId(
  clientId: string,
): Promise<{ data: UsinaByClient[]; total: number }> {
  const config: AxiosRequestConfig = {
    params: {
      clientId: clientId,
    },
  };
  const result = await api.get<UsinaByClient[]>(
    `${ROUTE}/All/byClientId`,
    config,
  );
  return {
    data: result.data,
    total: parseInt(result.headers["x-total-count"]),
  };
}

export async function getDailyReportUsina(
  date: string,
  usinaId: string,
): Promise<{ data: { url: string } }> {
  const config: AxiosRequestConfig = {
    params: {
      date: date,
      usinaId: usinaId,
    },
  };
  const result = await api.get<{ url: string }>(`Relatorios/diario`, config);
  return {
    data: result.data,
  };
}

export async function getReportsByInterval(
  interval: Number,
  date?: string,
  signal?: AbortSignal,
): Promise<{ data: { relatorioList: RelatorioContent[] } }> {
  const config: AxiosRequestConfig = {
    params: {
      interval,
      date,
    },
    signal,
  };

  const result = await api.get<{ relatorioList: RelatorioContent[] }>(
    `Relatorios/all-reports`,
    config,
  );
  return {
    data: result.data,
  };
}

export async function getDailyReportInfoUsina(
  date: string,
  usinaId: string,
): Promise<{
  data: { relatorioDiario: RelatorioDiarioData; errors: string[] };
}> {
  const config: AxiosRequestConfig = {
    params: {
      date: date,
      usinaId: usinaId,
    },
  };
  const result = await api.get<{
    relatorioDiario: RelatorioDiarioData;
    errors: string[];
  }>(`Relatorios/diario-info`, config);
  return {
    data: result.data,
  };
}

export async function getPersonalizedReportUsina(
  startDate: string,
  endDate: string,
  usinaId: string,
): Promise<{
  data: {
    relatorioPersonalizado: RelatorioPersonalizadoData;
    errors: string[];
  };
}> {
  const config: AxiosRequestConfig = {
    params: {
      startDate: startDate,
      endDate: endDate,
      usinaId: usinaId,
    },
  };
  const result = await api.get<{
    relatorioPersonalizado: RelatorioPersonalizadoData;
    errors: string[];
  }>(`Relatorios/personalizado`, config);
  return {
    data: result.data,
  };
}

export async function getMonthlyReportUsina(
  month: number,
  year: number,
  usinaId: string,
): Promise<{ data: { url: string } }> {
  const config: AxiosRequestConfig = {
    params: {
      month: month,
      year: year,
      usinaId: usinaId,
    },
  };
  const result = await api.get<{ url: string }>(`Relatorios/mensal`, config);
  return {
    data: result.data,
  };
}

export async function generateMonthlyReport(
  date: Date,
  usinasIds?: string[],
  sendNotifications?: boolean,
) {
  const result = await api.post(`Relatorios/mensal-generate`, {
    referenceDate: date,
    onlyUsinas: usinasIds ?? null,
    sendNotifications: sendNotifications ?? false,
  });
  return {
    data: result.data,
  };
}

export async function generateDailyReport(
  date: string,
  usinasIds?: string[],
  sendNotifications?: boolean,
) {
  const result = await api.post(`Relatorios/diario-history`, {
    dataDeReferencia: date,
    onlyUsinas: usinasIds ?? null,
    sendNotifications: sendNotifications ?? false,
  });
  return {
    data: result.data,
  };
}

export async function reprocessDailyReports(
  dataCorrecao: string,
  usinasIds?: string[],
  sendNotifications?: boolean,
) {
  const result = await api.post(`Relatorios/diario-reprocess`, {
    dataCorrecao,
    onlyUsinas: usinasIds ?? null,
    sendNotifications: sendNotifications ?? false,
  });
  return {
    data: result.data,
  };
}

export async function getMonthlyReportInfoUsina(
  month: number,
  year: number,
  usinaId: string,
): Promise<{
  data: { relatorioMensal: RelatorioMensalData; errors: string[] };
}> {
  const config: AxiosRequestConfig = {
    params: {
      month: month,
      year: year,
      usinaId: usinaId,
    },
  };
  const result = await api.get<{
    relatorioMensal: RelatorioMensalData;
    errors: string[];
  }>(`Relatorios/mensal-info`, config);
  return {
    data: result.data,
  };
}

export async function getDashboardHistory(
  usinaId: number,
  filter: string[],
): Promise<{ data: string[]; total: number }> {
  const config: AxiosRequestConfig = {
    params: {
      filter: filter.join(";"),
    },
  };
  const result = await api.get(`${ROUTE}/${usinaId}/dashboard-history`, config);
  return {
    data: result.data.cards,
    total: parseInt(result.headers["x-total-count"]),
  };
}

/** Resposta do snapshot diário do card 3002 (histórico por data). */
export type DashboardHistoryCentroOperacoesSolarEventosResponse = {
  card?: unknown;
  referenceDate?: string;
  includesMqttSnapshot?: boolean;
  sqlSnapshotSemantics?: string;
};

type UnknownRecord = Record<string, unknown>;

export type DashboardHistoryCentroOperacoesSolarEventosCurrentAlarm = {
  triggeredAt?: string;
  alarmDuration?: string;
  usinaName?: string;
  usinaCode?: string;
  code?: string;
  area?: string;
  severity?: number;
  isActive?: boolean;
  message?: string;
};

export async function getDashboardHistoryCentroOperacoesSolarEventos(
  usinaId: number,
  date: string,
): Promise<{
  data: {
    currentAlarms: DashboardHistoryCentroOperacoesSolarEventosCurrentAlarm[];
    referenceDate?: string;
    includesMqttSnapshot?: boolean;
    sqlSnapshotSemantics?: string;
  };
}> {
  const config: AxiosRequestConfig = {
    params: { date },
  };
  const result = await api.get<DashboardHistoryCentroOperacoesSolarEventosResponse>(
    `${ROUTE}/${usinaId}/dashboard-history/centro-operacoes-solar-eventos`,
    config,
  );
  const body = (result.data ?? {}) as UnknownRecord;
  const cardCandidate = body.card ?? body.Card;
  const card =
    cardCandidate && typeof cardCandidate === "object" && !Array.isArray(cardCandidate)
      ? (cardCandidate as UnknownRecord)
      : undefined;
  const currentAlarmsFromCard = card?.currentAlarms ?? card?.CurrentAlarms;
  const currentAlarmsFromBody = body.currentAlarms ?? body.CurrentAlarms;
  const currentAlarmsRaw = Array.isArray(currentAlarmsFromCard)
    ? currentAlarmsFromCard
    : Array.isArray(currentAlarmsFromBody)
      ? currentAlarmsFromBody
      : undefined;
  const currentAlarms = Array.isArray(currentAlarmsRaw)
    ? (currentAlarmsRaw as DashboardHistoryCentroOperacoesSolarEventosCurrentAlarm[])
    : [];

  return {
    data: {
      currentAlarms,
      referenceDate:
        typeof body.referenceDate === "string"
          ? body.referenceDate
          : typeof body.ReferenceDate === "string"
            ? (body.ReferenceDate as string)
            : undefined,
      includesMqttSnapshot:
        typeof body.includesMqttSnapshot === "boolean"
          ? body.includesMqttSnapshot
          : typeof body.IncludesMqttSnapshot === "boolean"
            ? (body.IncludesMqttSnapshot as boolean)
            : undefined,
      sqlSnapshotSemantics:
        typeof body.sqlSnapshotSemantics === "string"
          ? body.sqlSnapshotSemantics
          : typeof body.SqlSnapshotSemantics === "string"
            ? (body.SqlSnapshotSemantics as string)
            : undefined,
    },
  };
}

export async function getPartialReportPdf(
  date: string,
  clientId: string,
  userId: string,
): Promise<{ data: { url: string } }> {
  const config: AxiosRequestConfig = {
    params: {
      date: date,
      clientId: clientId,
      userId: userId,
    },
  };
  const result = await api.get<{ url: string }>(`Relatorios/parcial`, config);
  return {
    data: result.data,
  };
}

export async function getPartialReportInfo(
  date: string,
  clientId: string,
  userId: string,
): Promise<{
  data: { relatorioParcial: RelatorioParcialData; errors: string[] };
}> {
  const config: AxiosRequestConfig = {
    params: {
      date: date,
      clientId: clientId,
      userId: userId,
    },
  };
  const result = await api.get<{
    relatorioParcial: RelatorioParcialData;
    errors: string[];
  }>(`Relatorios/parcial-generate`, config);
  return {
    data: result.data,
  };
}
